export class RulebookLibraryMenu {
    id: number;
    libraryName: string;
    ruleBook: string;
    isCollapsed: boolean;
    isActive: boolean;
    url: string;
    isLibraryNameRequired: boolean;
    isLibraryNameExist: boolean;
    type:string;

    constructor() {
        this.id = 0;
        this.libraryName = '';
        this.ruleBook = '';
        this.isCollapsed = false;
        this.isActive = false;
        this.url = '';
        this.isLibraryNameRequired = false;
        this.isLibraryNameExist = false;
        this.type = '';
    }
}
export enum LibraryType {
    Reporting = 'Reporting',
    Rulebook = 'Rulebook',
}
export class ReportTempateModel{
    libraryNameAddUpdateInput:RulebookLibraryMenu;
    templateList:Array<number>;
    constructor(){
        this.libraryNameAddUpdateInput = new RulebookLibraryMenu();
        this.templateList = [];
    }
}